'use client';

import React from 'react';
import type { ShowcaseLabel } from '@/lib/public-showcase';

export default function ShowcaseBadge({
  label,
  isOpal = true,
  compact = false,
}: {
  label: ShowcaseLabel;
  isOpal?: boolean;
  compact?: boolean;
}) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: compact ? 9 : 10,
        fontWeight: 700,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: isOpal ? '#6d28d9' : '#c4b5fd',
        background: isOpal ? 'rgba(124,58,237,0.08)' : 'rgba(124,58,237,0.18)',
        border: `1px solid ${isOpal ? 'rgba(124,58,237,0.22)' : 'rgba(167,139,250,0.35)'}`,
        borderRadius: 6,
        padding: compact ? '1px 6px' : '2px 8px',
        flexShrink: 0,
      }}
    >
      {label}
    </span>
  );
}
